module.exports = __webpack_public_path__ + "img/lj.42dbcd20.png";